angular.module('app').controller('ApiDocumentationGatekeeperModalCtrl',
    ['$scope', '$uibModalInstance', 'modalConfig',
        function ($scope, $modalInstance, modalConfig) {
            'use strict';

            $scope.downloadingDocument = false;
            $scope.model = {
                Title: modalConfig.Title,
            };
            
            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            $scope.ok = ok;
            $scope.cancel = cancel;
        }]);
